/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassCapacityRow } from './ClassCapacityRow';
import {
    ClassCapacityRowFromJSON,
    ClassCapacityRowFromJSONTyped,
    ClassCapacityRowToJSON,
    ClassCapacityRowToJSONTyped,
} from './ClassCapacityRow';

/**
 * 
 * @export
 * @interface WidgetDataClassCapacityWidgetData
 */
export interface WidgetDataClassCapacityWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataClassCapacityWidgetData
     */
    $type?: WidgetDataClassCapacityWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<ClassCapacityRow>}
     * @memberof WidgetDataClassCapacityWidgetData
     */
    items: Array<ClassCapacityRow>;
}


/**
 * @export
 */
export const WidgetDataClassCapacityWidgetDataTypeEnum = {
    ClassCapacity: 'class-capacity'
} as const;
export type WidgetDataClassCapacityWidgetDataTypeEnum = typeof WidgetDataClassCapacityWidgetDataTypeEnum[keyof typeof WidgetDataClassCapacityWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataClassCapacityWidgetData interface.
 */
export function instanceOfWidgetDataClassCapacityWidgetData(value: object): value is WidgetDataClassCapacityWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataClassCapacityWidgetDataFromJSON(json: any): WidgetDataClassCapacityWidgetData {
    return WidgetDataClassCapacityWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataClassCapacityWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataClassCapacityWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(ClassCapacityRowFromJSON)),
    };
}

export function WidgetDataClassCapacityWidgetDataToJSON(json: any): WidgetDataClassCapacityWidgetData {
    return WidgetDataClassCapacityWidgetDataToJSONTyped(json, false);
}

export function WidgetDataClassCapacityWidgetDataToJSONTyped(value?: WidgetDataClassCapacityWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(ClassCapacityRowToJSON)),
    };
}

